import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppAccessService } from '../services/app-access.service';

export const rootRedirectGuard: CanActivateFn = () => {
  const appAccessService = inject(AppAccessService);
  const router = inject(Router);

  // If in restricted mode, redirect to form-builder
  if (appAccessService.isRestrictedMode()) {
    router.navigate(['/form-builder']);
    return false;
  }

  // If in free mode, redirect to login (normal behavior)
  router.navigate(['/login']);
  return false;
};
